/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Header_Explore_Use_Cases_LabelInputs */

const en_common_header_explore_use_cases_label = /** @type {(inputs: Common_Header_Explore_Use_Cases_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use Cases`)
};

const zh_common_header_explore_use_cases_label = /** @type {(inputs: Common_Header_Explore_Use_Cases_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使用场景`)
};

/**
* | output |
* | --- |
* | "Use Cases" |
*
* @param {Common_Header_Explore_Use_Cases_LabelInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_header_explore_use_cases_label = /** @type {((inputs?: Common_Header_Explore_Use_Cases_LabelInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Header_Explore_Use_Cases_LabelInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_header_explore_use_cases_label(inputs)
	return zh_common_header_explore_use_cases_label(inputs)
});
export { common_header_explore_use_cases_label as "common.header.explore.use_cases.label" }